import { useEffect, useRef } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
export function useInterval(callback, delay) {
  const callbackRef = useRef(callback);
  useIsomorphicLayoutEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(() => {
    if (typeof delay !== 'number' || Number.isNaN(delay)) {
      return null;
    }
    const id = setInterval(() => {
      callbackRef.current?.();
    }, delay);
    return function clean() {
      return clearInterval(id);
    };
  }, [delay]);
}